import { useI18n } from "../i18n";
import { Power, Volume2, Gauge, Mic, MicOff } from "lucide-react";
import { useMemo } from "react";
import { Slider } from "./ui/slider";

export const Controls = ({ active, onToggle, speed, setSpeed, volume, setVolume, voice, setVoice }) => {
  const { t } = useI18n();
  const speedValue = useMemo(() => [speed], [speed]);
  const volumeValue = useMemo(() => [volume], [volume]);
  return (
  <div className="panel p-5 grid gap-6 sm:grid-cols-[auto_1fr] items-center">
    <button
      onClick={onToggle}
      data-testid="ghost-session-toggle-btn"
      className={`power-btn ${active ? "power-on" : ""}`}
    >
      <Power size={22} />
      <span>{active ? t("stopSession") : t("startSession")}</span>
    </button>
    <div className="grid gap-5">
      <div className="flex items-center gap-4">
        <Gauge size={16} className="text-muted shrink-0" />
        <span className="label w-28 shrink-0">Sweep {speed}ms</span>
        <Slider data-testid="ghost-sweep-speed-slider" min={50} max={500} step={10} value={speedValue} onValueChange={(v) => setSpeed(v[0])} />
      </div>
      <div className="flex items-center gap-4">
        <Volume2 size={16} className="text-muted shrink-0" />
        <span className="label w-28 shrink-0">Volume {Math.round(volume * 100)}%</span>
        <Slider data-testid="ghost-volume-slider" min={0} max={1} step={0.05} value={volumeValue} onValueChange={(v) => setVolume(v[0])} />
        <button onClick={() => setVoice(!voice)} data-testid="ghost-voice-toggle" className="icon-btn" title={t("voice")}>
          {voice ? <Mic size={16} /> : <MicOff size={16} />}
        </button>
      </div>
    </div>
  </div>
);
};
